import React from "react";
import { Link } from "react-router-dom";
import "./ServicesList.css";

import img1 from "../assets/items/cytonn-photography-n95VMLxqM2I-unsplash.jpg";
import img2 from "../assets/items/towfiqu-barbhuiya-5m5418Ng6t8-unsplash.jpg";
import img3 from "../assets/items/ian-schneider-TamMbr4okv4-unsplash.jpg";

const items = [
  {
    title: "Leistungen",
    img: img1,
    description:
      "Entdecken Sie unser umfangreiches Angebot an qualitativ hochwertigen Serviceleistungen.",
    link: "/leistungen",
  },
  {
    title: "Reinigungspakete",
    img: img2,
    description:
      "Erkunden Sie unsere maßgeschneiderten Reinigungspakete, die auf Ihre spezifischen Bedürfnisse zugeschnitten sind.",
    link: "/pakete",
  },
  {
    title: "Über uns",
    img: img3,
    description:
      "Erfahren Sie mehr über unsere Vision, unsere Werte und was uns antreibt, die beste Autopflege zu bieten.",
    link: "/about",
  },
];

const ServicesList = () => (
  <div className="services-list">
    <h2 className="title">Entdecken Sie, was wir zu bieten haben</h2>
    {items.map((item, index) => (
      <div key={index} className="service-item">
        <img src={item.img} alt={item.title} />
        <h2>{item.title}</h2>
        <p>{item.description}</p>
        <Link to={item.link} className="more-info-button">
          Mehr Info
        </Link>
      </div>
    ))}
  </div>
);

export default ServicesList;
